import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
type PlanRecommendationProps = {
  plan: string;
  audience: string;
};
export function PlanRecommendation({
  plan,
  audience
}: PlanRecommendationProps) {
  return <section className="w-full bg-canvas-sky pb-20" aria-label="Recommended plan" data-id="element-1522" data-mp="3bi7kbcr21ugp">
      <div className="mx-auto max-w-shell px-6" data-id="element-1523" data-mp="36je6fj7uw1g0">
        <div className="flex flex-col gap-4 rounded-[14px] border border-brand/25 bg-white px-6 py-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-1524" data-mp="843icnj5nesh">
          <p className="flex items-center gap-3 text-[16px] text-ink" data-id="element-1525" data-mp="32nvqr1bx07z">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand" data-id="element-1526" data-mp="3u9qkzcxlwwfk">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-1527" data-mp="3q96swnrw4j0a" />
            </span>
            <span data-id="element-1528" data-mp="2ixg1jx4r6cns">
              Most {audience} start on <span className="font-semibold" data-id="element-1529" data-mp="2eujf1vc3dwek">{plan}</span>.
            </span>
          </p>
          <SmartLink href="/pricing" className="group inline-flex shrink-0 items-center gap-1.5 pl-12 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover sm:pl-0" data-id="element-1530" data-mp="3hbna5qiqeoef">
            Compare plans
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1531" data-mp="38ap12ttfrqoz" />
          </SmartLink>
        </div>
      </div>
    </section>;
}